<template>
  <div>
    <div class="row message-by-categories-row mt-2">
      <div class="col">
        <div class="pb-2">Message template by categories</div>
        <div class="d-flex flex-row align-items-center categories-row">
          <div class="form-check form-check-inline pr-15">
            <input
              class="form-check-input mr-2"
              id="isComplexionSelector"
              type="checkbox"
              v-model="isComplexion"
            />
            <label class="form-check-label" for="isComplexionSelector"
              >Complexion</label
            >
          </div>
          <div class="form-check form-check-inline pr-15">
            <input
              class="form-check-input mr-2"
              id="isCheekSelector"
              type="checkbox"
              v-model="isCheek"
            />
            <label class="form-check-label" for="isCheekSelector">Cheek</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input mr-2"
              id="isLipSelector"
              type="checkbox"
              v-model="isLip"
            />
            <label class="form-check-label" for="isLipSelector">Lip</label>
          </div>
          <button
            class="btn btn-outline-primary ml-auto"
            @click="addMessageTemplateByCategories"
          >
            Add
          </button>
        </div>
        <div
          v-if="isSubmit && error.errorByCategoriesMessageTemplates"
          class="text-error"
        >
          {{ error.errorByCategoriesMessageTemplates.message }}
        </div>
      </div>
    </div>
    <div
      class="message-by-categories-container p-3 mt-3"
      v-if="
        form.byCategoriesMessageTemplates &&
        form.byCategoriesMessageTemplates.length > 0
      "
    >
      <div class="mb-5">
        <v-expansion-panels v-model="panel" class="mt-2" multiple focusable>
          <v-expansion-panel
            v-for="(category, index) in form.byCategoriesMessageTemplates"
            :key="index"
            class="my-2 template-container mt-3"
            tabindex="-1"
            :id="'messageTemplate' + index"
          >
            <v-expansion-panel-header>
              <template>
                <div class="d-flex flex-row align-items-center h-25">
                  <div class="form-check form-check-inline pr-15">
                    <input
                      class="form-check-input mr-2"
                      id="isComplexion"
                      type="checkbox"
                      v-model="category.isComplexion"
                      disabled
                    />
                    <label class="form-check-label pt-1" for="isComplexion"
                      >Complexion</label
                    >
                  </div>
                  <div class="form-check form-check-inline pr-15">
                    <input
                      class="form-check-input mr-2"
                      id="isCheek"
                      type="checkbox"
                      v-model="category.isCheek"
                      disabled
                    />
                    <label class="form-check-label pt-1" for="isCheek"
                      >Cheek</label
                    >
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input mr-2"
                      id="isLip"
                      type="checkbox"
                      v-model="category.isLip"
                      disabled
                    />
                    <label class="form-check-label pt-1" for="isLip">Lip</label>
                  </div>
                  <div class="ml-auto mr-10">
                    <button
                      class="btn btn-outline-danger m-0"
                      @click="deleteMessageTemplateByCategories(index)"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <LineMessageTemplate
                v-if="form.isSentViaLine"
                :trigger-type="form.triggerType"
                :message-template="category.messageTemplates"
                :error-message-templates-array="
                  error.errorMessageTemplateLineList
                "
                :index="index"
                :error="error"
                :is-submit="isSubmit"
                :data-id="
                  'message-tooltip-line-' +
                  category.isComplexion +
                  '_' +
                  category.isCheek +
                  '_' +
                  category.isLip
                "
                :identifier="
                  category.isComplexion +
                  '_' +
                  category.isCheek +
                  '_' +
                  category.isLip
                "
                :is-focusable="true"
              />
              <SmsMessageTemplate
                v-if="form.isSentViaSms"
                :trigger-type="form.triggerType"
                :message-template="category.messageTemplates"
                :error-message-templates-array="
                  error.errorMessageTemplateSmsList
                "
                :index="index"
                :is-submit="isSubmit"
                :data-id="
                  'message-tooltip-sms-' +
                  category.isComplexion +
                  '_' +
                  category.isCheek +
                  '_' +
                  category.isLip
                "
                :identifier="
                  category.isComplexion +
                  '_' +
                  category.isCheek +
                  '_' +
                  category.isLip
                "
                :is-focusable="true"
              />
              <PushNotificationTemplate
                v-if="form.isSentViaPushNoti"
                :trigger-type="form.triggerType"
                :message-template="category.messageTemplates"
                :error-message-templates-array="
                  error.errorMessageTemplatePushNotiList
                "
                :index="index"
                :error="error"
                :is-submit="isSubmit"
                :data-id="
                  'message-tooltip-push-noti-' +
                  category.isComplexion +
                  '_' +
                  category.isCheek +
                  '_' +
                  category.isLip
                "
                :identifier="
                  category.isComplexion +
                  '_' +
                  category.isCheek +
                  '_' +
                  category.isLip
                "
                :is-focusable="true"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<script>
import SmsMessageTemplate from "components/MessageTemplate/SmsMessageTemplate.vue";
import LineMessageTemplate from "components/MessageTemplate/LineMessageTemplate.vue";
import PushNotificationTemplate from "components/MessageTemplate/PushNotificationTemplate.vue";
import DefaultMessageTemplateData from "components/MessageTemplate/defaultMessageTemplateData";

export default {
  name: "MessageTemplateByProductCategories",
  components: {
    PushNotificationTemplate,
    SmsMessageTemplate,
    LineMessageTemplate,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isCheek: false,
      isComplexion: false,
      isLip: false,
      panel: [],
    };
  },
  mounted() {
    if (this.form.byCategoriesMessageTemplates.length > 0) {
      this.form.byCategoriesMessageTemplates.forEach((_, i) =>
        this.panel.push(i)
      );
    }
  },
  methods: {
    addMessageTemplateByCategories() {
      const isDuplicateCategory = this.form.byCategoriesMessageTemplates?.some(
        (category) =>
          category.isComplexion === this.isComplexion &&
          category.isCheek === this.isCheek &&
          category.isLip === this.isLip
      );

      if (isDuplicateCategory) {
        let duplicateIndex = this.form.byCategoriesMessageTemplates.findIndex(
          (object) =>
            object.isComplexion === this.isComplexion &&
            object.isCheek === this.isCheek &&
            object.isLip === this.isLip
        );

        this.$nextTick(() => {
          document.getElementById("messageTemplate" + duplicateIndex)?.focus();
        });
      } else {
        this.form.byCategoriesMessageTemplates.push({
          isComplexion: this.isComplexion,
          isCheek: this.isCheek,
          isLip: this.isLip,
          messageTemplates: {
            ...DefaultMessageTemplateData,
            showPeriodInDays: null,
          },
        });
        this.$nextTick(() => {
          let index = this.form.byCategoriesMessageTemplates.length - 1;
          this.panel.push(index);
          document.getElementById("messageTemplate" + index)?.focus();
        });

        this.isComplexion = false;
        this.isCheek = false;
        this.isLip = false;
      }
    },
    deleteMessageTemplateByCategories(index) {
      this.form.byCategoriesMessageTemplates.forEach((_, i) => {
        if (i === index) {
          this.form.byCategoriesMessageTemplates.splice(index, 1);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  margin: 3rem 0;
}

.text-error {
  color: red;
  font-size: 12px;
}

.message-by-categories-row {
  max-height: 100px;
}

.categories-row {
  height: 25px;
}

.message-by-categories-container {
  border: 1px dashed #ccc;
  border-radius: 15px;
  margin-left: -20px !important;
  margin-right: -20px !important;
}

.template-container:focus {
  border: 4px solid #aac6fa;
  border-radius: 10px;
}
</style>
